import { zodResolver } from "@hookform/resolvers/zod";
import axios from "axios";
import { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { z } from "zod";
import config from "../../config/apiService.json";
import { ShowLayoutContext } from "../../context/showLayoutContext";

const schema = z.object({
  email: z.string().email({ message: "Invalid email address" }),
  password: z
    .string()
    .min(6, { message: "Password must be at least 6 characters long" }),
  recaptcha: z.string().min(1, { message: "ReCaptcha is required" }), // Added ReCaptcha validation
});

const useLogin = () => {
  const [, setIsInLoginPage] = useContext(ShowLayoutContext);
  const { baseApiEndPoint, login } = config;

  useEffect(() => {
    setIsInLoginPage(true);
  }, []);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  });

  const onSubmit = (data) => {
    const requestBody = { username: data.email, password: data.password };
    axios
      .post(`${baseApiEndPoint}${login}`, requestBody)
      .then(({ data: { success, payload, message } }) => {
        console.log(data);
        if (success) {
          loginProcess(payload);
        } else toast.error(message);
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.message);
      });
  };

  const handleRecaptchaChange = (token) => {
    setValue("recaptcha", token);
  };

  const loginProcess = (payload) => {
    // Set the cookie expiration time to a far-future date
    const expirationTime = new Date("9999-12-31T23:59:59.999Z");

    // Set the cookie value
    document.cookie = `access_token=${
      payload.accessToken
    }; expires=${expirationTime.toUTCString()}; path=/`;

    window.history.pushState(null, "", "/portal/admin/home");
    window.location.reload();
  };

  return { register, handleSubmit, onSubmit, handleRecaptchaChange, errors };
};

export default useLogin;
